<template src="./ClinicAndProfessionals.html" />

<script>
import { useStore } from "@/store/store.js"
import mixins from "../../../../Mixins.js"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"

export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      trySave: false,
      btnClicked: false,
      activeAlertTechnicalManager: true,
      specialtiesAdd: [],
      specialties: [],
      weekDaysAdd: [],
      specialtiesAddDoctor: [],
      clinicCareDataAdd: [],
      doctorsAdd: [],
      doctorAddTemp: {},
      clinicStatus: "active",
      popupAddDoctor: false,
      contactCellPhone: false,
      contactWhatsApp: false,
      contactViaEmail: false,
      contactSecretary: false,
      clickedPhoto: false,
      clickedProjectPhoto: false,
      id: 0,
      clinicProjectId: 0,
      clinic: [],
      contactObservation: "",
      imageData: "",
      imageDataProject: "",
      input: null,
      inputClinicProject: null,
      name: "",
      socialName: "",
      clinicProjectName: "",
      legalRepresentative: {
        name: "",
        cpf: "",
        crmNumber: "",
        crmState: ""
      },
      cnpj: "",
      contactEmail: "",
      previousContactEmail: "",
      assistantAdd: [],
      assistants: [{id: "", name: "", email: ""}],
      oscData: [{id: "", name: ""}],
      address: {
        zipcode: "",
        city: "",
        complement: "",
        neighborhood: "",
        number: "",
        state: "",
        street: ""
      },
      disableStreet: false,
      optionsClinic: [
        { text: "Seg", value: "MONDAY" },
        { text: "Ter", value: "TUESDAY" },
        { text: "Quar", value: "WEDNESDAY" },
        { text: "Qui", value: "THURSDAY" },
        { text: "Sex", value: "FRIDAY" },
        { text: "Sáb", value: "SATURDAY" }
      ],
      phone: "",
      invalidFields: {
        clinicProjectName: false,
        email: false,
        name: false,
        zipcode: false,
        number: false,
        street: false,
        socialName: false,
        cnpj: false,
        legalRepresentativeName: false,
        legalRepresentativeCPF: false,
        legalRepresentativeCRMNumber: false,
        legalRepresentativeCRMState: false,
        doctorAddName: false,
        doctorAddCPF: false,
        doctorAddCRMNumber: false,
        doctorAddCRMState: false,
        doctorAddEmail: false,
        contact: false,
        anyInvalidAssistant: false,
      },
      countAddSpecialtyDoctor: 0,
      showButtonSave: true,
      isProject: false,
      isDasa: false,
      training: {
        id: null,
        professionalTrained: "",
        trainingDate: "",
        trainingConcluded: false,
      }
    };
  },
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  watch: {
    contactEmail(newEmail) {
      if (this.assistants.length === 1 && this.assistants[0].email && this.assistants[0].name) {
        if (this.assistants[0].email === this.previousContactEmail) {
          this.assistants[0].email = newEmail;
        }
      }
      this.previousContactEmail = newEmail;
    }
  },
  mounted: function() {
    const vm = this;
    vm.previousContactEmail = vm.contactEmail;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getSpecialties();
      vm.addSpecialty();
      vm.addclinicCareData();
      if (vm.$route.params.id) {
        vm.showButtonSave = false;
        vm.getDataClinic(vm.$route.params.id);
        vm.getPhotoClinic(vm.$route.params.id);
      }
    },
    getDataClinic(idClinic) {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "webclinics/" + idClinic, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.fillDataClinic(response.data);
            vm.getTrainingData(idClinic);
          }
        });
    },
    getPhotoClinic(idClinic) {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "webclinics/photo/download/" + idClinic, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.imageData = `data:image/png;base64,${ response.data}`;
          }
        });
    },
    fillDataClinic(clinic) {
      const vm = this;
      vm.id = clinic.id;
      vm.name = clinic.name;
      vm.cnpj = clinic.cnpj;
      vm.contactEmail = clinic.contactEmail;
      vm.address = clinic.address;
      vm.address.zipcode = clinic.address.zipcode;
      vm.phone = clinic.phone;
      vm.contactCellPhone = clinic.contactPhone;
      vm.contactWhatsApp = clinic.contactWhatsApp;
      vm.contactViaEmail = clinic.contactByEmail;
      vm.contactSecretary = clinic.contactSecretary;
      vm.contactObservation = clinic.contactObservation;
      vm.isProject = clinic.isProject;
      this.isDasa = clinic.isDasa;

      if (vm.isProject) {
        vm.getClinicProjectData(vm.id);
      }
      vm.assistants = clinic.assistants;
      if(clinic.assistants.length == 0) {
        vm.assistants = [{id: "", name: "", email: ""}];
      }
      if(!vm.testNullUndefinedEmpty(vm.address)) {
        vm.disableStreet = true;
      }
    },
    getClinicProjectData(idClinic) {
      var vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "clinic-project/" + idClinic, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            if (response.data.id !== null && response.data.id !== undefined) {
              vm.getPhotoClinicProject(response.data.id)
            }
            vm.fillClinicProjectData(response.data);
          }
        });
    },
    getPhotoClinicProject(clinicProjectId) {
      var vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "clinic-project/photo/download/" + clinicProjectId, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.imageDataProject = `data:image/png;base64,${ response.data}`;
          }
        });
    },
    fillClinicProjectData(clinicProject) {
      let vm = this;
      vm.clinicProjectId = clinicProject.id;
      vm.clinicProjectName = clinicProject.name;
      vm.oscData = clinicProject.osc != null && clinicProject.osc.length > 0 ? clinicProject.osc : [{id: "", name: ""}];
    },
    clickAddNewDoctor() {
      const vm = this;
      vm.popupAddDoctor = true;
      vm.countAddSpecialtyDoctor = 0;
      vm.doctorAddTemp = {};
      vm.specialtiesAddDoctor = [];
    },
    removeDoctor(index) {
      const vm = this;
      vm.doctorsAdd.splice(index, 1);
    },
    validateAdditionDoctor() {
      const vm = this;
      let validFields = true;
      let specialtiesNull = false;
      if (vm.testNullUndefinedEmpty(vm.doctorAddTemp.name)) {
        validFields = false;
        vm.$vs.notify({
          title: "Ops..",
          text: "O campo nome é obrigatório",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
      }
      if (vm.validateCPF(vm.doctorAddTemp.cpf) == false) {
        vm.$vs.notify({
          title: "Ops..",
          text: "Digite um CPF válido",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (vm.validateEmail(vm.doctorAddTemp.email) == false) {
        vm.$vs.notify({
          title: "Ops..",
          text: "Digite um e-mail válido",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (vm.testNullUndefinedEmpty(vm.doctorAddTemp.crmNumber)) {
        vm.$vs.notify({
          title: "Ops..",
          text: "O campo Conselho Regional é obrigatório",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      if (vm.testNullUndefinedEmpty(vm.doctorAddTemp.crmState)) {
        vm.$vs.notify({
          title: "Ops..",
          text: "O campo Estado é obrigatório",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
        validFields = false;
      }
      for (let s in vm.specialtiesAddDoctor) {
        if (vm.specialtiesAddDoctor[s].length === 0) {
          specialtiesNull = true;
        }
      }
      if (specialtiesNull == true || vm.countAddSpecialtyDoctor == 0) {
        vm.$vs.notify({
          title: "Ops..",
          text: "Adicione ao menos uma especialidade",
          color: "warning",
          position: "top-right",
          icon: "error",
          time: 3000
        });
      }

      if (validFields == true) {
        vm.confirmAdditionDoctor();
      }
    },
    confirmAdditionDoctor() {
      const vm = this;
      let namesSpecialties = [];
      for (let s in vm.specialtiesAddDoctor) {
        namesSpecialties[s] = vm.specialtiesAddDoctor[s].name;
      }
      vm.doctorAddTemp = {
        name: vm.doctorAddTemp.name,
        crmNumber: vm.doctorAddTemp.crmNumber,
        crmState: vm.doctorAddTemp.crmState,
        email: vm.doctorAddTemp.email,
        cpf: vm.doctorAddTemp.cpf,
        specialties: vm.specialtiesAddDoctor,
        namesSpecialties: namesSpecialties.toString()
      };
      vm.doctorsAdd.push(new Object(vm.doctorAddTemp));
      vm.popupAddDoctor = false;
    },
    previewImage: function(event) {
      const vm = this;

      vm.input = event.target;

      if (vm.input.files && vm.input.files[0]) {

        let reader = new FileReader();

        reader.onload = e => {

          vm.imageData = e.target.result;
        };

        reader.readAsDataURL(vm.input.files[0]);
      }
    },previewImageProject: function(event) {
      let vm = this;

      vm.inputClinicProject = event.target;

      if (vm.inputClinicProject.files && vm.inputClinicProject.files[0]) {

        let reader = new FileReader();

        reader.onload = e => {

          vm.imageDataProject = e.target.result;
        };

        reader.readAsDataURL(vm.inputClinicProject.files[0]);
      }
    },
    async getAddressDataAndCheckFields(isToSave) {
      this.invalidFields.zipcode = !this.address.zipcode

      if (!this.invalidFields.zipcode) {
        const response = await this.getAddressByZipcode(this.address.zipcode)

        this.invalidFields.zipcode = !response || !response.address

        if (!this.invalidFields.zipcode) {
          this.address.city = response.address.city
          this.address.state = response.address.state
          this.address.state = response.address.state
          this.address.street = response.address.street

          this.disableStreet = !!this.address.street
          this.invalidFields.street = !this.address.street

          if (!isToSave) {
            this.address.number = ""
          }
        } else {
          this.address.street = ""
          this.address.number = ""
          this.address.city = ""
          this.address.state = ""
          this.address.complement = ""
          this.address.neighborhood = ""
          this.disableAddress.street = false
        }
      }

      if(isToSave) {
        this.saveOrUpdateClinic(!this.checkGeneralFieldsClinic())
      } else {
        this.checkGeneralFieldsClinic()
      }
    },
    addAssistant() {
      const vm = this;
      vm.toValidate = false;
      setTimeout(function() {
        vm.assistants.push({});
      }, 700);
    },
    removeAssistant(index) {
      const vm = this;
      setTimeout(function() {
        vm.assistants.splice(index, 1);
      }, 700);
    },
    addOSC() {
      const vm = this;
      vm.toValidate = false;
      setTimeout(function() {
        vm.oscData.push({});
      }, 700);
    },
    removeOSC(index) {
      const vm = this;
      setTimeout(function() {
        vm.oscData.splice(index, 1);
      }, 700);
    },
    addWeekDays() {
      const vm = this;
      setTimeout(function() {
        vm.weekDaysAdd.push([]);
      }, 700);
    },
    removeWeekDays(index) {
      const vm = this;
      setTimeout(function() {
        vm.weekDaysAdd.splice(index, 1);
      }, 700);
    },
    addclinicCareData() {
      const vm = this;
      setTimeout(function() {
        vm.clinicCareDataAdd.push([]);
        vm.addWeekDays();
      }, 700);
    },
    removeclinicCareData(index) {
      const vm = this;
      setTimeout(function() {
        vm.clinicCareDataAdd.splice(index, 1);
        vm.removeWeekDays(index);
      }, 700);
    },
    resetGeneralInvalidFieldsCLinic() {
      const vm = this;

      vm.invalidFields = {
        clinicProjectName: false,
        email: false,
        name: false,
        number: false,
        street: false,
        socialName: false,
        cnpj: false,
        legalRepresentativeName: false,
        legalRepresentativeCPF: false,
        legalRepresentativeCRMNumber: false,
        legalRepresentativeCRMState: false,
        doctorAddName: false,
        doctorAddCPF: false,
        doctorAddCRMNumber: false,
        doctorAddCRMState: false,
        doctorAddEmail: false,
        assistant: false,
        contact: false,
        anyInvalidAssistant: false
      };
    },
    checkGeneralFieldsClinic() {
      const vm = this;
      let isInvalid = vm.invalidFields;

      if(vm.trySave) {

        isInvalid.email = !vm.validateEmail(vm.contactEmail);
        isInvalid.name = vm.testNullUndefinedEmpty(vm.name);
        isInvalid.clinicProjectName = vm.isProject ? vm.testNullUndefinedEmpty(vm.clinicProjectName) : false;
        isInvalid.street = vm.testNullUndefinedEmpty(vm.address.street);
        isInvalid.number = vm.testNullUndefinedEmpty(vm.address.number);
        isInvalid.cnpj = !vm.validateCNPJ(vm.cnpj);
        isInvalid.contact = !(vm.contactCellPhone || vm.contactWhatsApp || vm.contactViaEmail || vm.contactSecretary);

        return isInvalid.email || isInvalid.name || isInvalid.zipcode || isInvalid.street
        || isInvalid.number || isInvalid.cnpj || isInvalid.anyInvalidAssistant || isInvalid.clinicProjectName;
      }
    },
    validateFieldsClinic() {
      const vm = this;
      vm.trySave = true;
      vm.resetGeneralInvalidFieldsCLinic();

      vm.getAddressDataAndCheckFields(true);

    },
    saveOrUpdateClinic(validFields) {
      const vm = this;

      if (validFields) {
        if(vm.id > 0) {
          vm.updateClinic();
        } else{
          vm.saveClinic();
        }
      } else {
        vm.$vs.notify({
          title: "Ops..",
          text:
            "Campos obrigatórios não preenchidos ou inválidos.",
          color: "warning",
          position: "top-right",
          align: "left",
          icon: "error",
          time: 3000
        });
      }
    },

    isHour(hour) {
      const vm = this;
      if (vm.testNullUndefinedEmpty(hour)) {
        return false;
      } else {
        let hourArray = hour.split(":");
        let partOne = hourArray[0];
        let parttTwo = hourArray[1];
        let intPartOne = parseFloat(partOne);
        let intPartTwo = parseFloat(parttTwo);
        if (intPartOne > 23 || intPartOne < 1 || intPartTwo > 59) {
          return false;
        } else {
          return true;
        }
      }
    },
    isInvalidAssistantName(index) {
      const vm = this;
      if (vm.trySave) {
        if (vm.testNullUndefinedEmpty(this.assistants[index].name)) {
          vm.invalidFields.anyInvalidAssistant = true;
          return true;
        }
        return false;
      }
    },
    isInvalidAssistantEmail(index) {
      const vm = this;
      if (vm.trySave && this.assistants[index].email) {
        if (vm.validateEmail(this.assistants[index].email) == false) {
          vm.invalidFields.anyInvalidAssistant = true;
          return true;
        }
        return false;
      }
    },
    saveClinic() {
      const vm = this;
      if(vm.btnClicked === true) {
        return
      }
      
      vm.btnClicked = true

      if (vm.assistants.length === 1 && !vm.assistants[0].name && !vm.assistants[0].email) {
        vm.assistants[0].name = vm.name;
        vm.assistants[0].email = vm.contactEmail;
      }

      let clinic = {
        address: vm.address,
        active: true,
        isProject: vm.isProject,
        isDasa: vm.isDasa,
        partner: true,
        name: vm.name,
        phone: vm.phone,
        cnpj: vm.cnpj.replace(/[^\d]+/g, ""),
        socialName: vm.socialName,
        contactEmail: vm.contactEmail,
        assistants: vm.assistants,
        contactPhone: vm.contactCellPhone,
        contactWhatsApp: vm.contactWhatsApp,
        contactByEmail: vm.contactViaEmail,
        contactSecretary: vm.contactSecretary,
        contactObservation: vm.contactObservation
      };

      vm.axios
        .post(vm.$store.state.filooServer + "webclinics", clinic, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            if(vm.isProject) {
              const clinicProject = {
                name: vm.clinicProjectName,
                description: "",
                osc: vm.oscData
              }

              vm.saveClinicProject(clinicProject, response.data.id)
            }

            vm.saveTraining(vm.training, response.data.id);

            if (vm.input !== null && vm.imageData !== "" && vm.input !== "") {
              vm.saveLogoClinic(response.data.id, response.data.name);

            } else {
              if (!vm.isProject) {
                vm.$vs.notify({
                  title: "Sucesso!",
                  text: "Os dados da clínica foram salvos com sucesso.",
                  color: "success",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right"
                });

                setTimeout(function () {
                  vm.$router.push("/clinics-registered");
                }, 1000);
              }
            }
          }
        })
        .catch(function(error) {
          const message = error && error.response && error.response.data && error.response.data.message

          if(message && message.includes("exception.user.already.exist.email")) {
            vm.$vs.notify({
              title: "O cadastro não pode ser concluído",
              text:
              "E-mail informado já utilizado, verifique se a clínica ou assistente(s) já não possuem cadastro",
              color: "warning",
              position: "top-right",
              align: "left",
              icon: "error",
              time: 6000
            });
            vm.btnClicked = false;
          } else if(message === "CNPJ já utilizado!") {
            vm.$vs.notify({
              title: "CNPJ já cadastrado",
              text: "O CNPJ informado já está sendo utilizado por outra clínica. Verifique os dados e tente novamente.",
              color: "warning",
              position: "top-right",
              align: "left",
              icon: "error",
              time: 6000
            });
            vm.btnClicked = false;
          } else {
            vm.showGenericErrorMessage();
            vm.btnClicked = false;
          }
        });
    },

    showGenericErrorMessage() {
      const vm = this;
      vm.$vs.notify({
        title: "Atenção!",
        text: "Ocorreu um erro, contacte o administrador do sistema.",
        color: "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "top-right"
      });
    },
    updateClinic() {
      const vm = this;
      if(vm.btnClicked == true) {
        return
      } else {
        vm.btnClicked = true;
      }
      let clinic = {
        id: vm.id,
        address: vm.address,
        active: true,
        isProject: vm.isProject,
        isDasa: vm.isDasa,
        partner: true,
        name: vm.name,
        phone: vm.phone,
        cnpj: vm.cnpj.replace(/[^\d]+/g, ""),
        socialName: vm.socialName,

        contactEmail: vm.contactEmail,

        assistants: vm.assistants,
        contactPhone: vm.contactCellPhone,
        contactWhatsApp: vm.contactWhatsApp,
        contactByEmail: vm.contactViaEmail,
        contactSecretary: vm.contactSecretary,
        contactObservation: vm.contactObservation
      };

      vm.axios
        .put(vm.$store.state.filooServer + "webclinics/" + vm.id, clinic, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            if(vm.isProject) {
              const clinicProject = {
                name: vm.clinicProjectName,
                description: "",
                osc: vm.oscData,
              }
              if (vm.clinicProjectId !== undefined && vm.clinicProjectId > 0){
                vm.updateClinicProject(clinicProject);
              } else {
                vm.saveClinicProject(clinicProject, vm.id)
              }
            }
            if (vm.training.id !== undefined && vm.training.id > 0){
                vm.updateTraining(vm.training, vm.id);
              } else {
                vm.saveTraining(vm.training, vm.id)
              }
            if (vm.input !== null && vm.imageData !== "" && vm.input !== "") {
              vm.saveLogoClinic(response.data.id, response.data.name);
            } else {
              if (!vm.isProject) {
                vm.$vs.notify({
                  title: "Sucesso!",
                  text: "Os dados da clínica foram salvos com sucesso.",
                  color: "success",
                  iconPack: "feather",
                  icon: "icon-check",
                  position: "top-right"
                });

                setTimeout(function () {
                  vm.$router.push("/clinics-registered");
                }, 1000);
              }
            }
          }
        })
        .catch(function(error) {
          const message = error && error.response && error.response.data && error.response.data.message

          if(message && message.includes("exception.user.already.exist.email")) {
            vm.$vs.notify({
              title: "O cadastro não pode ser concluído",
              text:
              "E-mail informado já utilizado, verifique se a clínica ou assistente(s) já não possuem cadastro",
              color: "warning",
              position: "top-right",
              align: "left",
              icon: "error",
              time: 6000
            });
            vm.btnClicked = false;
          } else if(message === "CNPJ já utilizado!") {
            vm.$vs.notify({
              title: "CNPJ já cadastrado",
              text: "O CNPJ informado já está sendo utilizado por outra clínica. Verifique os dados e tente novamente.",
              color: "warning",
              position: "top-right",
              align: "left",
              icon: "error",
              time: 6000
            });
            vm.btnClicked = false;
          } else {
            vm.showGenericErrorMessage();
            vm.btnClicked = false;
          }
        });
    },


    getSpecialties() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "specialties", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.specialties = response.data;
          }
        });
    },
    async getZipcodeData(zipcode) {
      if (/^[0-9]{5}-[0-9]{3}$/.test(zipcode)) {
        const response = await this.getAddressByZipcode(this.address.zipcode)
        if (response && response.address) {
          this.city = response.address.city
          this.state = response.address.state
          this.street = response.address.street
        }
      }
    },
    addSpecialty() {
      const vm = this;
      setTimeout(function() {
        vm.specialtiesAdd.push([]);
      }, 700);
    },
    removeSpecialty(index) {
      const vm = this;
      setTimeout(function() {
        vm.specialtiesAdd.splice(index, 1);
      }, 700);
    },
    addSpecialtyDoctor() {
      const vm = this;
      vm.countAddSpecialtyDoctor = +1;
      setTimeout(function() {
        vm.specialtiesAddDoctor.push([]);
      }, 700);
    },
    removeSpecialtyDoctor(index) {
      const vm = this;
      setTimeout(function() {
        vm.specialtiesAddDoctor.splice(index, 1);
      }, 700);
    },
    saveLogoClinic(idClinic, clinicName) {
      const vm = this;
      const formData = new FormData();

      formData.append("file", vm.input.files[0], vm.input.files[0].name);

      vm.axios
        .post(
          vm.$store.state.filooServer + "webclinics/photo/upload/" + idClinic,
          formData,
          {
            headers: { Authorization: vm.$session.get("bearer") },
            "Content-Type": "multipart/form-data"
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            if (!vm.isProject) {
              vm.$vs.notify({
                title: "Sucesso!",
                text:
                  "Os dados da clínica " +
                  clinicName +
                  " foram salvos com sucesso.",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right"
              });
              setTimeout(function () {
                vm.$router.push("/clinics-registered");
              }, 1000);
            }
          }
        })
        .catch(function() {
          vm.$vs.notify({
            title: "Atenção!",
            text:
              "Ocorreu um erro em salvar a logo da clínica, contacte o administrador do sistema.",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right"
          });
        });
    },
    saveLogoClinicProject(clinicProjectId) {
      let vm = this;
      const formData = new FormData();

      formData.append("file", vm.inputClinicProject.files[0], vm.inputClinicProject.files[0].name);

      vm.axios
        .post(
          vm.$store.state.filooServer + "clinic-project/photo/upload/" + clinicProjectId,
          formData,
          {
            headers: { Authorization: vm.$session.get("bearer") },
            "Content-Type": "multipart/form-data"
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text:
                "Os dados da clínica foram salvos com sucesso.",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right"
            });
            setTimeout(function() {
              vm.$router.push("/clinics-registered");
            }, 1000);
          }
        })
        .catch(function() {
          vm.$vs.notify({
            title: "Atenção!",
            text:
              "Ocorreu um erro em salvar a logo da clínica, contacte o administrador do sistema.",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "top-right"
          });
        });
    },
    saveClinicProject(clinicProject, webClinicId) {
      const vm = this;
      vm.axios
        .post(vm.$store.state.filooServer + `clinic-project/${webClinicId}`, clinicProject, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            if (vm.inputClinicProject !== null && vm.imageDataProject !== "" && vm.inputClinicProject !== "") {
              vm.saveLogoClinicProject(response.data.id);
            }
          }
        })
    },
    updateClinicProject(clinicProject) {
      const vm = this;
      vm.axios
        .put(vm.$store.state.filooServer + "clinic-project/" + vm.clinicProjectId, clinicProject, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            if (vm.inputClinicProject !== null && vm.imageDataProject !== "" && vm.inputClinicProject !== "") {
              vm.saveLogoClinicProject(response.data.id);
            } else {
              vm.$vs.notify({
                title: "Sucesso!",
                text: "Os dados da clínica foram salvos com sucesso.",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-right"
              });

              setTimeout(function() {
                vm.$router.push("/clinics-registered");
              }, 1000);
            }
          }
        })
        .catch(function(error) {
          const message = error && error.response && error.response.data && error.response.data.message

          if(message && message.includes("exception.user.already.exist.email")) {
            vm.$vs.notify({
              title: "O cadastro não pode ser concluído",
              text:
                "E-mail informado já utilizado, verifique se a clínica ou assistente(s) já não possuem cadastro",
              color: "warning",
              position: "top-right",
              align: "left",
              icon: "error",
              time: 6000
            });
            vm.btnClicked = false;
          } else {
            vm.showGenericErrorMessage();
            vm.btnClicked = false;
          }
        });
    },
    saveTraining(training, webClinicId) {
      const vm = this;
      vm.axios
        .post(vm.$store.state.filooServer + `webclinics/training/${webClinicId}`, training, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
    },
    updateTraining(training, webClinicId) {
      const vm = this;
      vm.axios
        .put(vm.$store.state.filooServer + `webclinics/training/${webClinicId}`, training, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
    },
    getTrainingData(idClinic) {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "webclinics/training/" + idClinic, {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.fillTrainingData(response.data);
          }
        });
    },
    fillTrainingData(response) {
      const vm = this;
      vm.training.id = response.id;
      vm.training.professionalTrained = response.professionalTrained;
      vm.training.trainingDate = response.trainingDate;
      vm.training.trainingConcluded = response.trainingConcluded;
    }
  }
};
</script>
<style lang="scss" src="./ClinicAndProfessionals.scss">
</style>
